export const handleDownload = (mediaSrc: string) => {
  // Create a temporary anchor element to trigger download
  const link = document.createElement('a');
  link.href = mediaSrc || '';
  link.download = mediaSrc?.split('/').pop() || 'download';
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const handleDownloads = (mediaSrc: string) => {
  // Fetch the file as a blob and trigger download
  fetch(mediaSrc)
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = mediaSrc?.split('/').pop() || 'download';
      link.setAttribute('download', link.download);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.error('Download failed:', error);
    });
};

export const getRelativeTime = (timestamp: string): string => {
  const now = new Date();
  const past = new Date(timestamp);
  const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds}s ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays}d ago`;
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return `${diffInWeeks}w ago`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return `${diffInMonths}mo ago`;
  }

  const diffInYears = Math.floor(diffInDays / 365);
  return `${diffInYears}y ago`;
};

export const handlePhotoClick = (
  photo: any,
  navigate: (path: string) => void,
  dispatch: any,
  setSelectedMedia: any,
  mediaViewRoute: string
) => {
  // Determine media type based on file extension or metadata
  const getMediaType = (url: string): 'image' | 'video' => {
    const extension = url.split('.').pop()?.toLowerCase();
    const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm'];
    return videoExtensions.includes(extension || '') ? 'video' : 'image';
  };

  const mediaType = getMediaType(photo.url || '');
  const mediaData = {
    assetId: photo.id,
    mediaType,
    mediaSrc: photo.url || '',
    name: photo.fileName || ''
  };

  // Store media data in Redux
  dispatch(setSelectedMedia(mediaData));

  // Navigate with just the asset ID
  navigate(`${mediaViewRoute}/${photo.id}`);
};

export const getFileSizeString = (sizeInBytes: number): string => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} B`;
  } else if (sizeInBytes < 1048576) {
    return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  } else if (sizeInBytes < 1073741824) {
    return `${(sizeInBytes / 1048576).toFixed(1)} MB`;
  } else {
    return `${(sizeInBytes / 1073741824).toFixed(1)} GB`;
  }
};
